import { DataAccess } from "../../dataaccess/data.access";
import { Invalidate } from "../../decorators/cache.decorator";

export namespace SeInit {
    export type CatalogOutcome = "MISSING" | "INSERTED" | "ALREADY_EXISTED";

    export interface CatalogItem {
        id?: number;
        badgeKey?: string;
        catalogLabel: string;
        dataType?: string;
        outcome: CatalogOutcome;
    }

    export interface Catalog {
        eventCategories: CatalogItem[];
        organizationCategories: CatalogItem[];
        organizationCustomAttributes: CatalogItem[];
        contactCustomAttributes: CatalogItem[];
        engagementBadges: CatalogItem[];
    }

    export interface InitResponse {
        inserted: {
            categories: string[];
            customAttributes: string[];
            engagementBadges: string[];
        };
        alreadyExisted: {
            categories: string[];
            customAttributes: string[];
            engagementBadges: string[];
        };
        errors: string[];
        catalog: Catalog;
    }

    export interface InitStatusResponse {
        isInitialized: boolean;
        missingItems: {
            workflow: boolean;
            categories: string[];
            customAttributes: string[];
            engagementBadges: string[];
        };
        catalog: Catalog;
    }

    export interface DemoSeedResponse {
        inserted: {
            ingestionPoints: string[];
            workflowProcesses: string[];
        };
        alreadyExisted: {
            ingestionPoints: string[];
            workflowProcesses: string[];
        };
        errors: string[];
    }

    export interface DemoSeedStatusResponse {
        demoLoaded: boolean;
        missingForms: string[];
        existingForms: string[];
    }
}

export class SeInitService {
    /**
     * Initialize workflow system and Connect25 master definitions.
     */
    @Invalidate({ serviceName: "EventService", methodName: "getEventTypeById" })
    public static initialize(): Promise<SeInit.InitResponse> {
        return DataAccess.post<SeInit.InitResponse>("/student-engagement/init/initialize.json");
    }

    /**
     * Get initialization status for workflow and Connect25 master definitions.
     */
    public static getStatus(): Promise<SeInit.InitStatusResponse> {
        return DataAccess.get<SeInit.InitStatusResponse>("/student-engagement/init/status.json");
    }

    /**
     * Seed optional Connect25 demo forms and workflows (ANG-7497).
     */
    public static seedDemoData(): Promise<SeInit.DemoSeedResponse> {
        return DataAccess.post<SeInit.DemoSeedResponse>("/student-engagement/demo-seed/seed.json");
    }

    /**
     * Whether seed data has already been loaded on this instance.
     */
    public static getDemoSeedStatus(): Promise<SeInit.DemoSeedStatusResponse> {
        return DataAccess.get<SeInit.DemoSeedStatusResponse>("/student-engagement/demo-seed/status.json");
    }
}
